import { PureComponent } from "react";

import { QESButton, QESTextInput } from "@app/shared/qes-standards";
import { FlyoutContextOutgoingProps, FlyoutFooter, withFlyoutContext } from "@app/shared/Flyouts";

interface AddLicensePanelProps {
  clientName: string;
  onAddLicense: (sfContractId: string) => void;
}

interface AddLicensePanelState {
  sfContractId: string
}

class WrappedAddLicensePanelContent extends PureComponent<AddLicensePanelProps & FlyoutContextOutgoingProps, AddLicensePanelState> {
  constructor(props: AddLicensePanelProps & FlyoutContextOutgoingProps) {
    super(props);
    this.state = {
      sfContractId: ""
    };
  }

  private handleSFContractIdChange(text: string) {
    const numRegex = /(^\d+$|^$)/g;
    this.setState((prevState) => ({
      sfContractId: numRegex.test(text) ? text : prevState.sfContractId
    }));
  }

  private handleAddClick = () => {
    this.props.onAddLicense(this.state.sfContractId);
    this.props.handleCloseFlyout();
  }

  public render() {
    return (
      <>
        <QESTextInput
          containerClassName="col-8 p-0"
          label="SF Contract ID"
          testId="add-license-panel-content__sfContractId"
          value={this.state.sfContractId}
          onChange={(e) => this.handleSFContractIdChange(e.target.value)} />

        <FlyoutFooter
          submitButton={<QESButton
            qesTestId="add-license-panel-content__confirm"
            className="mr-2"
            onClick={() => { this.handleAddClick(); }}
          >
            Add
          </QESButton>
          }
        />
      </>
    );
  }
}

const AddLicensePanelContent = withFlyoutContext(WrappedAddLicensePanelContent);
export default AddLicensePanelContent;